// Shared site-wide configuration
export const topNavItems = [
  { label: "Business", link: "/business" },
  { label: "Customer", link: "/customer" },
  { label: "About us", link: "/about-us" },
];

export const footerLinks = [
  { href: '/customer/category', text: 'Category pages' },
  { href: '/business/add-a-new-spot', text: 'Add a new spot' },
  { href: 'https://www.wheretospot.com/forum', text: 'Forum' },
  { href: 'https://www.wheretospot.com/faq', text: 'Privacy & Policy' },
];

// Navigation configurations by section
export const navigationConfigs = {
  business: [
    { label: 'Add your Business', link: '/business/add-a-new-spot' },
    { label: 'Pricing', link: 'https://www.wheretospot.com/plans-pricing' },
    { label: 'Sign in', link: 'https://www.wheretospot.com/event-list' },
  ],
  customer: [
    { label: 'Events', link: 'https://www.wheretospot.com/event-list' },
    { 
      label: 'Guides', 
      link: '#', 
      subItems: [
        { label: 'Dahab Guide', link: '/customer/dahab-guide' },
        { label: 'Dahab Guide', link: '/customer/dahab-guide' },
        { label: 'Dahab Guide', link: '/customer/dahab-guide' },
        { label: 'Dahab Guide', link: '/customer/dahab-guide' },
        { label: 'Dahab Guide', link: '/customer/dahab-guide' },
        { label: 'Dahab Guide', link: '/customer/dahab-guide' },
      ] 
    },
    { label: 'Sign in', link: 'https://www.wheretospot.com/event-list' },
  ],
  about: [
    { label: 'Sign in', link: 'https://www.wheretospot.com/event-list' },
  ],
};

// Shared partner data
export const samplePartners = [
  { image: '/assets/logo-test.png', href: 'https://partner1.com' },
  { image: '/assets/logo-test.png', href: 'https://partner2.com' },
  { image: '/assets/logo-test.png', href: 'https://partner3.com' },
  { image: '/assets/logo-test.png', href: 'https://partner4.com' },
  { image: '/assets/logo-test.png', href: 'https://partner5.com' },
  { image: '/assets/logo-test.png', href: 'https://partner6.com' },
  { image: '/assets/logo-test.png', href: 'https://partner7.com' },
  { image: '/assets/logo-test.png', href: 'https://partner8.com' },
  { image: '/assets/logo-test.png', href: 'https://partner9.com' },
  { image: '/assets/logo-test.png', href: 'https://partner10.com' },
];
